// export const apiUrl = 'http://127.0.0.1:8000/apis/';
// export const assetsUrl = 'http://127.0.0.1:8000/storage/uploads/';

// export const apiUrl = 'http://ppttool.sangamniti.org/apibackend/apis/';
// export const assetsUrl = 'http://172.16.0.143/api/uploaded_files/';
// export const fileserverUrl = 'http://172.16.0.143/api/upload-files/';

export const apiUrl = 'https://www.theinkorporated.com/inkapi/apibackend/apis/';
export const assetsUrl = 'https://www.theinkorporated.com/api/uploaded_files/';
export const fileserverUrl = 'https://www.theinkorporated.com/api/upload-files/';